import { SearchBox } from '@appd/uik';

type Props = Pick<SearchBox.Props, 'className' | 'onChange' | 'placeholder' | 'value'>;

export function DashifySearchBox({ className, onChange, placeholder, value }: Props) {
  return <SearchBox className={className} onChange={onChange} placeholder={placeholder} value={value} />;
}
